import mapValues from 'lodash/mapValues';
import { map } from 'rxjs/operators';

import { getBrowseCategoryConfig } from 'app/api/BrowseApi';
import BrowseConstants from 'app/constants/BrowseConstants';
import { mapCatalogRecordBibToDisplayBib } from 'app/helpers/displayBib';

export const fetchCategoryUiConfig = ({ categoryPath, postSuccess }) => {
  return {
    apiRequest: (_state, apiClient) => {
      return getBrowseCategoryConfig(apiClient, categoryPath).pipe(
        map(res => {
          const { body } = res;
          const { bibsByCategoryPath = {} } = body;

          const displayBibsByCategoryPath = mapValues(bibsByCategoryPath, bibs =>
            bibs.map(mapCatalogRecordBibToDisplayBib)
          );

          return { body: { ...res.body, bibsByCategoryPath: displayBibsByCategoryPath } };
        })
      );
    },
    postSuccess,
    types: [
      BrowseConstants.FETCH_BROWSE_CATEGORY_REQUEST,
      BrowseConstants.FETCH_BROWSE_CATEGORY_SUCCESS,
      BrowseConstants.FETCH_BROWSE_CATEGORY_FAILURE
    ]
  };
};
